"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Checkmark = void 0;
var _jsxRuntime = require("react/jsx-runtime");
const Checkmark = () => {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M19.0422 3.52513L8.86524 13.7022C8.80821 13.7592 8.73087 13.7911 8.65025 13.7911C8.56962 13.7911 8.49229 13.7592 8.43525 13.7022L4.95025 10.2172C4.89322 10.1602 4.81588 10.1282 4.73526 10.1282C4.65463 10.1282 4.5773 10.1602 4.52026 10.2172L1.80328 12.9342C1.7463 12.9913 1.71429 13.0686 1.71429 13.1492C1.71429 13.2299 1.7463 13.3072 1.80328 13.3642L5.5023 17.0632L8.43525 19.9961C8.49229 20.0531 8.56962 20.0851 8.65025 20.0851C8.73087 20.0851 8.80821 20.0531 8.86524 19.9961L22.1967 6.66471C22.2537 6.60767 22.2857 6.53034 22.2857 6.44971C22.2857 6.36908 22.2537 6.29175 22.1967 6.23471L19.4797 3.51768C19.4508 3.4888 19.4165 3.46606 19.3786 3.45075C19.3408 3.43545 19.3002 3.42793 19.2594 3.42863C19.2185 3.42933 19.1783 3.43817 19.141 3.45476C19.1037 3.47136 19.0701 3.49528 19.0422 3.52513Z"
    })
  });
};
exports.Checkmark = Checkmark;